
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"32","viewBox":"0 0 20 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 17.032h-6.18a3 3 0 00-1.82-1.82v-3.18h3.17a4.33 4.33 0 001.3-8.5 6 6 0 00-11.41 1.63 3.5 3.5 0 00.94 6.87h4v3.18a3 3 0 00-1.82 1.82H1a1 1 0 000 2h6.18a3 3 0 005.64 0H19a1 1 0 100-2zm-14-7a1.5 1.5 0 110-3 1 1 0 001-1 4 4 0 017.79-1.29 1 1 0 00.78.67 2.31 2.31 0 011.93 2.29 2.34 2.34 0 01-2.33 2.33H5zm5 9a1 1 0 110-2 1 1 0 010 2z","fill":"#D8F3DC"}})])
          )
        }
      }
    